export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend my Sunday nights dreading lesson planning from scratch. Now I open The Vault, pick my progression, and hit the court with total confidence. My students noticed the professional shift immediately.',
    author: 'J. Bennett',
    role: 'Senior Instructor',
    location: 'London, UK',
  },
  {
    quote:
      'The “Magic Cues” cheat sheet alone is worth the entire price. It transformed how I fix technical errors in real time. I’m no longer guessing; I’m correcting with precision.',
    author: 'M. Thompson',
    role: 'Head Pro',
    location: 'Toronto, Canada',
  },
]
